import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformInfoService } from '../platform-service/platform-info.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private httpClient = inject(HttpClient);
  private platformInfoService = inject(PlatformInfoService);

  private version: Record<string, string> | undefined;
  private build: Record<string, string> | undefined;
  private platform: Record<string, string> | undefined;
  private languageHeader: Record<string, string> | undefined;

  get https(): HttpClient {
    return this.httpClient;
  }

  setLanguage(chosenLanguage: string) {
    this.languageHeader = {
      'x-clinch-language': chosenLanguage,
    };
  }

  generateHeaders(): HttpHeaders {
    const headers = {
      ...this.versionHeader(),
      ...this.buildHeader(),
      ...this.platformHeader(),
      ...(this.languageHeader ?? {}),
    };
    return new HttpHeaders(headers);
  }

  generateAuthHeaders(idToken: string): HttpHeaders {
    const headers = {
      ...this.authorizationHeader(idToken),
      ...this.versionHeader(),
      ...this.buildHeader(),
      ...this.platformHeader(),
      ...(this.languageHeader ?? {}),
    };
    return new HttpHeaders(headers);
  }

  private authorizationHeader(idToken: string): Record<string, string> {
    return { Authorization: `Bearer ${idToken}` };
  }

  private versionHeader(): Record<string, string> {
    if (!this.version) {
      this.version = {
        'x-clinch-version': environment.version,
      };
    }
    return this.version;
  }

  private buildHeader(): Record<string, string> {
    if (!this.build) {
      this.build = {
        'x-clinch-build': `${environment.build}`,
      };
    }
    return this.build;
  }

  private platformHeader(): Record<string, string> {
    if (!this.platform) {
      this.platform = {
        'x-clinch-platform': this.platformInfoService.getPlatform(),
      };
    }
    return this.platform;
  }
}
